import React from "react";
import { useTranslation } from "react-i18next";

import "../../styles/theme.css";
import "../../styles/dashboard.css";
import "../../styles/ProfilesManager.css";
import "../../styles/helpProfile.css";

export default function Helpprompt() {
  const { t } = useTranslation("help");

  return (
    <div className="theme-whbl">
      {/* Header */}

      <div className="container-fluid">
        <div className="row">
          <style>
            {`
              .dark-guide-table {
                width: 100%;
                border-collapse: collapse;
                table-layout: fixed;
                font-family: "Segoe UI", Arial, sans-serif;
                font-size: 14px;
                color: #e5e7eb;
                background: #1E293B;
                border: 1px solid #374151;
              }

              .dark-guide-table thead th {
                background: #1E293B;
                color: #60a5fa;
                font-weight: 700;
                text-align: left;
                padding: 12px 14px;
                border: 1px solid #4b5563;
                vertical-align: middle;
              }

              .dark-guide-table tbody td {
                background: #1E293B;
                color: #e5e7eb;
                padding: 12px 14px;
                border: 1px solid #374151;
                vertical-align: top;
                line-height: 1.55;
              }

              .dark-guide-table th:nth-child(1),
              .dark-guide-table td:nth-child(1) {
                width: 23%;
              }

              .dark-guide-table th:nth-child(2),
              .dark-guide-table td:nth-child(2) {
                width: 30%;
              }

              .dark-guide-table th:nth-child(3),
              .dark-guide-table td:nth-child(3) {
                width: 47%;
              }

              @media (max-width: 768px) {
                .dark-guide-table {
                  min-width: 750px;
                }
              }
            `}
          </style>

          <main
            style={{
              width: "97%",
              overflowX: "auto",
            }}
          >
            <div className="dashboard">
              {/* Page Header */}
              <div className="pm-header">
                <div className="pm-title-section">
                  <h1 className="pm-title">
                    {t("helpPrompt.title")}
                  </h1>
                </div>
              </div>

              {/* Prompt Profile Help Content */}
              <div>
                {t("helpPrompt.intro.description")}
                <br />
                <br />
                <img
                  className="help-img"
                    src={t("helpPrompt.intro.image")}
                  alt={t("helpPrompt.intro.imageAlt")}
                />
                <br />
                <br />
               <img      className="help-img"       src={t("helpPrompt.intro.image2")}   /><br/><br/>
               <img      className="help-img"       src={t("helpPrompt.intro.image3")}   /><br/><br/>
               <img      className="help-img"       src={t("helpPrompt.intro.image4")}   /><br/><br/>
               <img      className="help-img"       src={t("helpPrompt.intro.image5")}   /><br/><br/>
                <br />
                <br />
              </div>

              <table className="dark-guide-table">
                <thead>
                  <tr>
                    <th>{t("helpPrompt.table.headers.control")}</th>
                    <th>{t("helpPrompt.table.headers.purpose")}</th>
                    <th>{t("helpPrompt.table.headers.detail")}</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>{t("helpPrompt.table.rows.apiEndpoint.control")}</td>
                    <td>{t("helpPrompt.table.rows.apiEndpoint.purpose")}</td>
                    <td>{t("helpPrompt.table.rows.apiEndpoint.detail")}</td>
                  </tr>

                  <tr>
                    <td>{t("helpPrompt.table.rows.apiHeaders.control")}</td>
                    <td>{t("helpPrompt.table.rows.apiHeaders.purpose")}</td>
                    <td>{t("helpPrompt.table.rows.apiHeaders.detail")}</td>
                  </tr>

                  <tr>
                    <td>{t("helpPrompt.table.rows.inputScript.control")}</td>
                    <td>{t("helpPrompt.table.rows.inputScript.purpose")}</td>
                    <td>{t("helpPrompt.table.rows.inputScript.detail")}</td>
                  </tr>

                  <tr>
                    <td>{t("helpPrompt.table.rows.outputScript.control")}</td>
                    <td>{t("helpPrompt.table.rows.outputScript.purpose")}</td>
                    <td>{t("helpPrompt.table.rows.outputScript.detail")}</td>
                  </tr>

                  <tr>
                    <td>{t("helpPrompt.table.rows.maliciousDataInsertion.control")}</td>
                    <td>{t("helpPrompt.table.rows.maliciousDataInsertion.purpose")}</td>
                    <td>{t("helpPrompt.table.rows.maliciousDataInsertion.detail")}</td>
                  </tr>

                  <tr>
                    <td>{t("helpPrompt.table.rows.behavioralThreats.control")}</td>
                    <td>{t("helpPrompt.table.rows.behavioralThreats.purpose")}</td>
                    <td>{t("helpPrompt.table.rows.behavioralThreats.detail")}</td>
                  </tr>

                  <tr>
                    <td>{t("helpPrompt.table.rows.fileFormat.control")}</td>
                    <td>{t("helpPrompt.table.rows.fileFormat.purpose")}</td>
                    <td>{t("helpPrompt.table.rows.fileFormat.detail")}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}